<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Employees Performance Report</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small text to="/sales-summary">
          <v-icon left>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <div>
          <v-row dense>
            <!-- Date From -->
            <v-col cols="12" xs="12" md="4">
              <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field dense outlined single-line v-model="record.StartDate" label="From"
                    prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
                </template>
                <v-date-picker v-model="record.StartDate" @input="menu1 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <!-- Date To -->
            <v-col cols="12" xs="12" md="4">
              <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field dense outlined single-line v-model="record.EndDate" label="To"
                    prepend-icon="mdi-calendar-month" v-on="on" readonly></v-text-field>
                </template>
                <v-date-picker v-model="record.EndDate" @input="menu2 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <!-- Shop Filter -->
            <v-col cols="12" xs="12" md="4">
              <v-autocomplete
                name="shopFilter"
                dense
                outlined
                v-model="record.StoreId"
                :items="stores"
                label="Select Shop"
                item-text="Name"
                item-value="id"
                clearable
              ></v-autocomplete>
            </v-col>

            <!-- Brand Filter -->
            <v-col cols="12" xs="12" md="4">
              <v-autocomplete
                name="brandFilter"
                dense
                outlined
                v-model="record.BrandId"
                :items="brands"
                label="Select Brand"
                item-text="Name"
                item-value="id"
                clearable
              ></v-autocomplete>
            </v-col>

            <!-- Product Filter -->
            <v-col cols="12" xs="12" md="5">
              <v-autocomplete
                name="productFilter"
                dense
                outlined
                v-model="record.ProductId"
                :items="products"
                :search-input.sync="searchProducts"
                label="Select Product"
                item-text="Name"
                item-value="id"
                clearable
              ></v-autocomplete>
            </v-col>

            <!-- Actions -->
            <v-col cols="12" xs="12" md="3" class="d-flex align-center">
              <v-btn @click="getReport" color="primary" :loading="loader" class="mr-3">
                <v-icon left>mdi-chart-multiple</v-icon>Generate
              </v-btn>
              <v-btn small text color="accent" @click="clearFilters">
                <v-icon left small>mdi-filter-remove</v-icon>Clear
              </v-btn>
            </v-col>
          </v-row>

          <v-divider class="mb-4 mt-4"></v-divider>

          <div v-if="reportData.length > 0">
            <v-row dense class="subtitle-2 text--primary">
              <v-col cols="12" xs="12" md="6">
                <!-- <div v-if="selectedBrandName" class="style-14">Brand: <strong class="primary--text">{{ selectedBrandName }}</strong></div>
                <div v-if="selectedProductName" class="style-14">Product: <strong class="primary--text">{{ selectedProductName }}</strong></div> -->
                <!-- <div v-if="selectedStoreName" class="style-14">Shop: <strong class="primary--text">{{ selectedStoreName }}</strong></div> -->
                <div class="style-14">Grand Total Sales: {{ grandTotal | currency }}</div>
                <div class="style-14">Total Quantity Sold: {{ grandQuantity }}</div>
                <download-excel :data="reportData" :fields="fields" name="Employees Performance Report" class="mt-2">
                  <v-icon color="green">mdi-file-excel</v-icon>
                </download-excel>
              </v-col>
            </v-row>

            <v-row dense class="subtitle-2 text--primary">
              <v-col cols="12">
                <v-text-field label="Search" v-model="search" dense></v-text-field>
                <v-data-table
                  :mobile-breakpoint="0"
                  :items-per-page="25"
                  :headers="headers"
                  :items="reportData"
                  :search="search"
                  :loading="loader"
                  loading-text="Loading performance data..."
                  class="font-weight-medium"
                >
                  <template v-slot:item.Rank="{ item }">
                    {{ reportData.indexOf(item) + 1 }}
                  </template>

                  <template v-slot:item.TotalSales="{ item }">
                    {{ item.TotalSales | currency }}
                  </template>

                  <template v-slot:item.TotalQuantity="{ item }">
                    {{ item.TotalQuantity.toLocaleString() }}
                  </template>

                  <template v-slot:no-data>
                    <v-alert :value="true" color="info" icon="mdi-information">
                      No performance data found for the selected criteria.
                    </v-alert>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </div>

          <div v-else-if="!loader">
            <v-alert type="info" class="mt-4">
              <v-icon left>mdi-information</v-icon>
              Select a date range and click "Generate" to view employees performance ranked by sales.
            </v-alert>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      record: {
        StartDate: null,
        EndDate: null,
        BrandId: null,
        ProductId: null,
        StoreId: null,
      },
      menu1: false,
      menu2: false,
      search: null,
      loader: false,
      brands: [],
      products: [],
      stores: [],
      searchProducts: null,
      reportData: [],
      grandTotal: 0,
      grandQuantity: 0,
      totalInvoices: 0,
      headers: [
        { text: "#", value: "Rank", sortable: false },
        { text: "Employee", value: "UserName" },
        { text: "Qty Sold", value: "TotalQuantity" },
        { text: "Total Sales", value: "TotalSales" },
      ],
      fields: {
        Employee: "UserName",
        QtySold: "TotalQuantity",
        TotalSales: "TotalSales",
      },
    };
  },
  computed: {
    selectedProductName() {
      if (!this.record.ProductId) return null;
      const product = this.products.find((p) => p.id === this.record.ProductId);
      return product ? product.Name : null;
    },
    selectedBrandName() {
      if (!this.record.BrandId) return null;
      const brand = this.brands.find((b) => b.id === this.record.BrandId);
      return brand ? brand.Name : null;
    },
    selectedStoreName() {
      if (!this.record.StoreId) return null;
      const store = this.stores.find((s) => s.id === this.record.StoreId);
      return store ? store.Name : null;
    },
  },
  watch: {
    searchProducts(val) {
      if (val && typeof val === "string" && val.length > 1) {
        this.querySelections(val);
      }
    },
  },
  methods: {
    clearFilters() {
      this.record.BrandId = null;
      this.record.ProductId = null;
      this.record.StoreId = null;
      this.record.StartDate = null;
      this.record.EndDate = null;
    },
    querySelections(searchText) {
      const self = this;
      const url = "/products/search";
      const data = { SearchText: searchText.toString() };
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200 && res.ResponseData != null) {
            self.products = res.ResponseData;
          }
        })
        .catch(() => {});
    },
    getReport() {
      if (!this.record.StartDate || !this.record.EndDate) {
        this.$refs.snackbar.show("Please select both start and end dates", "red");
        return;
      }
      const data = { ...this.record };
      const url = "/employees-performance-report";
      const self = this;

      self.loader = true;
      self.reportData = [];
      self.grandTotal = 0;
      self.grandQuantity = 0;
      self.totalInvoices = 0;

      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.reportData = res.ResponseData.employeeSales || [];
            self.grandTotal = res.ResponseData.grandTotal || 0;
            self.grandQuantity = res.ResponseData.grandQuantity || 0;
            self.totalInvoices = res.ResponseData.totalInvoices || 0;
          } else {
            self.$refs.snackbar.show(res.msg || res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.$refs.snackbar.show(err, "red");
        })
        .finally(() => {
          self.loader = false;
        });
    },
    getBrands() {
      const self = this;
      this.$store
        .dispatch("get", `/brands`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.brands = res.ResponseData;
          }
        })
        .catch(() => {});
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          }
        })
        .catch(() => {});
    },
  },
  created() {
    this.getBrands();
    this.getStores();
  },
};
</script>

<style lang="scss" scoped>
.style-14 {
  font-weight: 500;
  font-size: 14px;
  line-height: 1.6;
}
</style>
